import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import './shared/axiosAuth';
import AuthGate from './shared/AuthGate';
import App from './App';
import { AppDialogHost } from './shared/AppDialogs';
import { SITE_ORIGIN } from './shared/site/siteContent';

// "[DEV]" on the browser tab in dev, for every screen (back office, sign-in
// and the Customer portal). NODE_ENV is inlined at build time, so a
// production build never has it.
const IS_DEV = process.env.NODE_ENV !== 'production';
if (IS_DEV) document.title = `[DEV] ${document.title}`;

// The Site Icon from Company Settings, on every page (website, Customer
// portal, back office). The API may be on another address, so the link is
// set here, where REACT_APP_API_URL is known; with no icon set the address
// answers 404 and browsers show their default icon.
const siteIconUrl = `${process.env.REACT_APP_API_URL || ''}/api/site/icon`;
for (const rel of ['icon', 'apple-touch-icon']) {
  const link = document.createElement('link');
  link.rel = rel;
  if (rel === 'icon') link.type = 'image/png';
  link.href = siteIconUrl;
  document.head.appendChild(link);
}

// Once kronigsupply.com.au serves Optim (issue #291), REACT_APP_REDIRECT_TO_SITE
// is set to true in Render, and any other address (optim-b2b-frontend.onrender.com)
// sends the visitor to the same page on kronigsupply.com.au, so the site has
// one address (issue #367).
const { origin, pathname, search, hash } = window.location;
if (process.env.REACT_APP_REDIRECT_TO_SITE === 'true' && origin !== SITE_ORIGIN) {
  window.location.replace(SITE_ORIGIN + pathname + search + hash);
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <AuthGate>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthGate>
      <AppDialogHost />
    </React.StrictMode>
  );
}
